import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { CommunityNotice } from '@shared/types';

export function useNotices(area?: string) {
  const [notices, setNotices] = useState<CommunityNotice[]>([]);

  useEffect(() => {
    const qs = area ? `?area=${encodeURIComponent(area)}` : '';
    api
      .get<{ notices: CommunityNotice[] }>(`/notices${qs}`)
      .then((res) => setNotices(res.notices))
      .catch(() => setNotices([]));
  }, [area]);

  return notices;
}
